import { Box, Grow, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import ButtonMapMenuClose from "assets/icons/btn_mapmenu_close.svg";
import IconTimer from "assets/icons/isochrone/ic_timer.svg";
import React from "react";
import { isMobile, isMobileOnly } from "react-device-detect";
import styles from "./IsochroneDialog.module.scss";
import { MinutesSlider } from "./components/MinutesSlider";
import { ProfileButton } from "./components/ProfileButton";
import { useIsochroneDialogHooks } from "./hooks";
import { IsochroneDialogProps } from "./interfaces";

const idPrefix = "isochrone-dialog";

export const IsochroneDialog = React.memo((props: IsochroneDialogProps) => {
  const hooks = useIsochroneDialogHooks(props);

  const { boxRef, titRef } = hooks;

  return (
    <Dialog
      open={props.open}
      aria-labelledby={`${idPrefix}-title`}
      aria-describedby={`${idPrefix}-description`}
      onClose={(e, reason) =>
        reason !== "escapeKeyDown" && props.onClose && props.onClose()
      }
      slotProps={{
        backdrop: { className: styles.backdrop },
        paper: { onClick: hooks.onBackPaperClick }
      }}
      classes={{
        scrollPaper: styles.paperScrollPaper,
        paper: styles.paper,
        container: styles.container
      }}
      slots={{ transition: Grow }}
      transitionDuration={{ appear: 200, enter: 200, exit: 100 }}
    >
      <Box className={`${styles.popup_map} twbasic01 ${styles.on}`}>
        <Box className={styles.scroll}>
          <Box className={styles.tit} ref={titRef}>
            <Box component="span">
              <img src={IconTimer} alt="到達圏" />
            </Box>
            <Box className={styles.btn_sub_close} onClick={props.onClose}>
              <img src={ButtonMapMenuClose} alt="閉じる" />
              <Typography component="b">閉じる</Typography>
            </Box>
          </Box>
          <Box className={styles.box} ref={boxRef}>
            <Box className={styles.box2}>
              <Box className={styles.ovfl}>
                <Box className={styles.popup_map_filter}>
                  <Box className={styles.ctt}>
                    <Box
                      className={`${styles.func_v2} ${styles.slider_v2} ${
                        styles.price
                      } ${
                        isMobileOnly
                          ? styles.isMobileOnly
                          : isMobile
                            ? styles.isMobile
                            : ""
                      }`}
                    >
                      <ProfileButton
                        walking={hooks.walking}
                        cycling={hooks.cycling}
                        driving={hooks.driving}
                        onWalkingChange={hooks.onWalkingChange}
                        onCyclingChange={hooks.onCyclingChange}
                        onDrivingChange={hooks.onDrivingChange}
                      />
                    </Box>
                    <Box
                      className={`${styles.func_v2} ${styles.slider_v2} ${
                        styles.size
                      } ${
                        isMobileOnly
                          ? styles.isMobileOnly
                          : isMobile
                            ? styles.isMobile
                            : ""
                      }`}
                    >
                      <MinutesSlider
                        sliderTheme={hooks.sliderTheme}
                        id="rooms-slider"
                        value={hooks.minutes}
                        formattedMinutes={hooks.formattedMinutes}
                        onChange={hooks.onMinutesChange}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box className={`${styles.popup_map_btn} ${styles.btn_3ko}`}>
              <Box
                className={`${styles.btn} ${styles.cancel}`}
                onClick={props.onClose}
              >
                閉じる
              </Box>
              <Box
                className={`${styles.btn} ${styles.arrow} ${
                  hooks.okButtonOn ? styles.on : styles.off
                }`}
                onClick={hooks.onOkButtonClick}
              >
                表示
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
});
